import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";
import config from "./config";


export const ApplicationScreenshotsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListApplicationScreenshots) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateApplicationScreenshot) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to={config.basePath}/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetApplicationScreenshot) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to={config.basePath}/>
                    )
                }

            >
            </Route>

        </Routes>
    );
};
